"use client";

import { usePublicEnv, type PublicEnv } from "@/lib/public-env-context";

const LABEL_POR_AMBIENTE: Record<PublicEnv["environment"], string | null> = {
  development: "Ambiente de desenvolvimento — dado não é de produção",
  staging: "Ambiente de homologação — dado não é de produção",
  production: null,
};

/**
 * Aviso visual de ambiente não produtivo. Prova de conceito da configuração pública
 * em runtime (ver src/lib/public-env-context.tsx e
 * docs/adr/0012-config-runtime-por-ambiente.md): o mesmo build exibe um rótulo
 * diferente em DEV, HML e PRD porque o valor vem do Contexto, calculado a cada
 * requisição pelo Server Component raiz — nunca embutido no JavaScript no momento
 * do build.
 */
export function EnvironmentBanner() {
  const { environment } = usePublicEnv();
  const label = LABEL_POR_AMBIENTE[environment];

  if (!label) {
    return null;
  }

  return (
    <div
      role="status"
      className="w-full bg-amber-500 px-4 py-1.5 text-center text-sm font-medium text-amber-950"
    >
      {label}
    </div>
  );
}
